import { Box, TableCell, Paper, TableContainer, Table } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContentSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background["paper-elevation-0"],
  padding: `${theme.spacing(5)} ${theme.spacing(7)}`,
  flex: "1",
}));

export const TablePaper = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  borderRadius: theme.shape.borderRadius,
}));

export const StyledTableContainer = styled(TableContainer)({
  borderRadius: "8px",
  border: "none",
  borderColor: "transparent",
});

export const StyledTable = styled(Table)({
  tableLayout: "fixed",
  width: "100%",
});

interface StyledTableCellProps {
  isSortable?: boolean;
}

export const StyledTableHeaderCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isSortable",
})<StyledTableCellProps>(({ theme, isSortable = false }) => ({
  backgroundColor: "#E9E2EF",
  padding: theme.spacing(3),
  cursor: isSortable ? "pointer" : "default",
  border: "none",
  borderRight: "1px solid #FFF",
  "&:last-child": {
    borderRight: "none",
  },
}));

export const HeaderCellContent = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(3),
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: theme.spacing(9),
  paddingBottom: theme.spacing(9),
  gap: theme.spacing(3),
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(7),
  paddingBottom: theme.spacing(7),
}));
